import { MutableRefObject, useRef, useEffect } from "react";

export const useOutsideEvent = <
    T extends HTMLElement,
    K extends keyof DocumentEventMap,
    C extends (event: DocumentEventMap[K]) => void
>(
    elRef: MutableRefObject<T | null>,
    eventName: K,
    callback: C
) => {
    const callbackRef = useRef<C>();
    callbackRef.current = callback;

    useEffect(() => {
        const listener = (event: DocumentEventMap[K]) => {
            if (
                callbackRef.current &&
                !elRef.current?.contains(event.target as T)
            ) {
                callbackRef.current(event);
            }
        };
        document.addEventListener(eventName, listener, true);
        return () => document.removeEventListener(eventName, listener, true);
    }, [elRef, eventName]);
};
